import React, { FC, useEffect, useRef, useState } from 'react';
import './style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import QuestionBox from 'src/components/molecules/content/QuestionBox';

interface Props {
  checkSurvey: any;
  id: string;
  viewType?: string;
}

const Spouse: FC<Props> = ({ viewType, checkSurvey, id }) => {
  const queStyle = { width: '400px' };
  const queSet = {
    question: [
      {
        idx: 0,
        status: 'this',
        confirm: '',
        set: {
          question: '귀하의 성별은?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: (
                  <div className="_text">
                    여성인 경우 '예'를, 남성인 경우는 아니오를 클릭해주세요.
                  </div>
                ),
              },
            ],
          },
        },
      },
      {
        idx: 1,
        status: 'ready',
        confirm: '',
        set: {
          question: '종합소득금액이 3천만원 이하입니까?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: (
                  <div className="_text">
                    근로소득만 있는 경우에는 총급여액 41,470,588원 이하일때 근로소득금액 3천만원
                    이하임.
                  </div>
                ),
              },
            ],
          },
        },
      },
      {
        idx: 2,
        status: 'ready',
        set: {
          question: '배우자가 있습니까?',
          style: queStyle,
          desc: [],
        },
      },
    ],
    answer: {
      status: 'ready',
      set: {
        title: '기본공제를 받을 수 없습니다.',
        status: 'no',
        desc: {
          data: [
            {
              text: (
                <div className="_text">이때, 총 급여액은 비과세 소득을 제외한 금액을 말합니다.</div>
              ),
            },
          ],
        },
      },
    },
  };

  const [queState, setQueState] = useState({ set: queSet.question });
  const [awsState, setAwsState] = useState({ set: queSet.answer });

  useEffect(() => {
    const queEndStatus = queState.set.filter((item: any) => item.status !== 'end');
    // const queConfirmStatus = queState.set.filter((item: any) => item.confirm === 'yes');

    if (queEndStatus.length === 0) {
      awsState.set.status = 'end';
      let answerSet = false;
      if (
        queState.set[0].confirm === 'yes' &&
        queState.set[1].confirm === 'yes' &&
        queState.set[2].confirm === 'no'
      )
        answerSet = true;

      if (!answerSet) {
        awsState.set.set.title = '부녀자공제를 받을 수 없습니다.';
        awsState.set.set.status = 'no';
      } else {
        awsState.set.set.title = '부녀자공제를 받을 수 있습니다.';
        awsState.set.set.status = 'yes';
      }

      setAwsState({ set: awsState.set });
    } else {
      awsState.set.status = 'ready';
      setAwsState({ set: awsState.set });
    }
  }, [queState]);

  const confirmEvent = () => {
    checkSurvey('Y', id);
  };

  return (
    <div className="_spouse_question_div">
      <div className="que_box">
        <QuestionBox
          queSet={queSet}
          queState={queState}
          setQueState={setQueState}
          awsState={awsState}
          setAwsState={setAwsState}
        />
      </div>
      {awsState.set.set.status === 'yes' ? (
        <div className="_confirm_btn_div">
          <DefaultButton
            text="기본공제 적용하기"
            clickEvent={e => confirmEvent()}
            styleDef={{ fontSize: '13px', width: '210px', height: '38px' }}
            type="type5"
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Spouse;
